var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vca-card',{staticClass:"shadowed"},[_c('h2',[_vm._v(_vm._s(_vm.$t("overview.dashboard.admin")))])])
}
var staticRenderFns = []

export { render, staticRenderFns }